const contentful = require('contentful-management');

const client = contentful.createClient({
  accessToken: 'CFPAT-V6u737ohELqYTSWzo5uRXymg6RNg83DgnanmbDmIQIg'
})

export default client
